"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UserSelectionCss = _interopRequireDefault(require("./UserSelection.css.js"));

var _radium = _interopRequireDefault(require("radium"));

var _LinkButton = _interopRequireDefault(require("./LinkButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuickLinks = function QuickLinks(_ref) {
  var tracking = _ref.tracking,
      email = _ref.email,
      quickLinks = _ref.quickLinks,
      theme = _ref.theme;
  var longListStyle = Object.assign({}, _UserSelectionCss.default['linksContainer'], _UserSelectionCss.default['scrollBox']);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: quickLinks.length > 6 ? longListStyle : _UserSelectionCss.default['linksContainer']
  }, quickLinks.length > 0 && quickLinks.map(function (link, idx) {
    return /*#__PURE__*/_react.default.createElement(_LinkButton.default, {
      idx: idx,
      key: "quick-link-".concat(idx),
      link: link,
      theme: theme,
      tracking: tracking,
      email: email
    });
  }));
};

var _default = (0, _radium.default)(QuickLinks);

exports.default = _default;

//# sourceMappingURL=QuickLinks.jsx.map